import Vue from "vue";
import Router from "vue-router";
import defaultViewSettings from "./domain/view_settings/data";

const Login = () => import("./views/login/View.vue");
import HomeWrapper from "./views/home/HomeWrapper.vue";
const DataOverview = () => import("./views/vessel-performance/DataOverview.vue");
const Comparison = () => import("./views/vessel-performance/Comparison.vue");
const FoulingEvents = () => import("./views/Fouling/FoulingEvents.vue");
const VesselAlertsView = () => import("./views/alerts/vessel/View.vue");
const WeatherRouting = () => import("./views/weather_routing/View.vue");
const VoyageDetails = () => import("./views/weather_routing/voyage/details/View.vue");
const CreateRoute = () => import("./views/weather_routing/route/new/View.vue");
const CreateArea = () => import("./views/weather_routing/area/new/View.vue");
const WeatherRoutingTabView = () => import("./views/weather_routing/TabView.vue");
const FleetAlertsView = () => import("./views/alerts/Fleet/View.vue");
const VesselInfoView = () => import("./views/vessel_information/View.vue");
const NotFound = () => import("./views/InactiveFeature.vue");
const KDiagramRouteView = () => import("./views/k_diagram/RouteView.vue");
const MainView = () => import("./views/Main.vue");
const CIIView = () => import("./views/cii/View.vue");
const PerformanceDashboardView = () => import("./views/performance_dashboard/View.vue");

const checkFeatureFlag = (flagName) => {
  try {
    return defaultViewSettings[flagName];
  } catch (error) {
    return false;
  }
};

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "main",
      redirect: {
        name: "home"
      },
      component: MainView,
      children: [
        {
          path: "vessel/:vessel/alerts",
          name: "Alerts Settings",
          component: VesselAlertsView,
          beforeEnter: (_, __, next) => {
            if (checkFeatureFlag("usesAlerts")) {
              next();
            } else {
              next({ name: "Inactive Feature" });
            }
          }
        },
        {
          path: "fleet/alerts",
          name: "Fleet Alerts",
          component: FleetAlertsView,
          beforeEnter: (_, __, next) => {
            if (checkFeatureFlag("usesAlerts")) {
              next();
            } else {
              next({ name: "Inactive Feature" });
            }
          }
        },
        {
          path: "/home",
          name: "home",
          component: HomeWrapper,
          beforeEnter: (to, from, next) => {
            const fleetEnabled = checkFeatureFlag("useFleetDashboard");

            // If no query → force vessel
            if (!to.query.view) {
              return next({ name: "home", query: { view: "vessel" } });
            }

            // If fleet requested but disabled → redirect to vessel
            if (to.query.view === "fleet" && !fleetEnabled) {
              return next({ name: "home", query: { view: "vessel" } });
            }

            next();
          }
        },
        {
          path: "vessel/:vessel",
          name: "Vessel Info",
          component: VesselInfoView
        },
        {
          path: "vessel/:vessel/data-overview",
          name: "Data Overview",
          component: DataOverview
        },
        {
          path: "vessel/:vessel/k-diagram",
          name: "K-Diagram",
          component: KDiagramRouteView
        },
        {
          path: "vessel/:vessel/cii",
          name: "CII",
          component: CIIView
        },
        {
          path: "vessel/:vessel/fouling",
          name: "Fouling",
          component: FoulingEvents
        },
        {
          path: "vessel/:vessel/sister-comparison",
          name: "Vessel Comparisons",
          component: Comparison
        },
        {
          path: "vessel/:vessel/fouling-events",
          name: "Cleaning History",
          component: FoulingEvents
        },
        {
          path: "vessel/:vessel/performance-dashboard",
          name: "Performance Dashboard",
          component: PerformanceDashboardView
        },
        {
          path: "vessel/:vessel/weather-routing",
          name: "Weather Routing",
          component: WeatherRouting,
          redirect: {
            name: "Weather Routing",
            path: "options"
          },
          beforeEnter: (_, __, next) => {
            if (checkFeatureFlag("usesWeatherRoutingView")) {
              next();
            } else {
              next({ name: "Inactive Feature" });
            }
          },
          children: [
            {
              name: "Weather Routing",
              path: "options",
              component: WeatherRoutingTabView
            },
            {
              name: "Voyage Details",
              path: "voyage-details/:voyageId",
              component: VoyageDetails
            },
            {
              name: "Create Route",
              path: "create-route",
              component: CreateRoute
            },
            {
              name: "Create Area",
              path: "create-area",
              component: CreateArea
            },
          ]
        },
      ]
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "*",
      name: "Inactive Feature",
      component: NotFound
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.fullPath !== "/login") {

    const token = localStorage.getItem("quad_token");
    if (!token) {
      next("/login");
    }
    else {
      next();
    }
  }
  else { next(); }
});

export default router;
